import axios from 'axios'
import store from '@/store'
import { Notify, Toast } from 'vant'
import { objPropTrim } from '@/utils/index'
import { getToken } from '@/utils/auth'

// 禁用IE下get请求缓存
axios.defaults.headers.get['Cache-Control'] = 'no-cache'
axios.defaults.headers.get.Pragma = 'no-cache'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  timeout: 50000 // request timeout
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 自动去除参数中字符串前后的空格
    if (config.data) {
      objPropTrim(config.data)
    }
    if (config.params) {
      objPropTrim(config.params)
    }
    if (store.getters.token) {
      config.headers.Authorization = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0
    })
    // config.headers['Accept-Language'] = store.getters.language
    // config.headers.eiversion = process.env.EIVERSION
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data
    Toast.clear()
    // 后台抛出异常
    if (res.status && res.status === 30101) {
      Notify({
        type: 'warning',
        title: '提示',
        message: res.message,
        duration: 2000
      })
      // 服务器异常
    } else if (res.status && res.status !== 200) {
      Notify({
        type: 'danger',
        message: res.message,
        duration: 5000
      })
    } else {
      return response.data
    }
    return {}
  },
  error => {
    console.error('err:' + error) // for debug
    const response = error.response
    // 服务超时
    if (response === undefined) {
      Notify({
        type: 'danger',
        message: '服务请求超时',
        duration: 5000
      })
      return Promise.reject(error)
    }
    const info = response.data
    // 已经被登场，是否重复登录
    if (response.status === 401 || info.status === 40101) {
      Notify({
        type: 'danger',
        message: '登录超时',
        duration: 2000
      })
      return Promise.reject('error')
    }
    // 禁止
    if (response.status === 403) {
      Notify({
        type: 'danger',
        title: '禁止',
        message: info.message,
        duration: 2000
      })
      return Promise.reject('error')
    }
    // 后端服务异常
    if (response.status === 504) {
      Notify({
        type: 'danger',
        message: '后端服务异常，请联系管理员',
        duration: 5000
      })
      return Promise.reject(error)
    }
    Notify({
      type: 'danger',
      message: info.message,
      duration: 5000
    })
    return Promise.reject(error)
  }
)

export default service
